import React, { useState, useEffect } from 'react';
import {
  Typography,
  Box,
  Paper,
  Container,
  Button,
  Grid,
  Tabs,
  Tab,
  Alert,
} from '@mui/material';
import { PageHeader } from '../common/PageHeader';
import {
  ArrowBack as ArrowBackIcon,
  Home as HomeIcon,
  BugReport as BugReportIcon,
  NavigateNext as NavigateNextIcon,
  MonitorHeart as MonitorHeartIcon,
  CheckCircle as CheckCircleIcon,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import BugReportForm from './BugReportForm';
import LogCollector from '../status/LogCollector';
import BugReportsAdmin from '../admin/BugReportsAdmin'; // Import the existing BugReportsAdmin

const BugReportPage = ({darkMode, toggleDarkMode, themeVariant}) => {
  const navigate = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [reportSuccess, setReportSuccess] = useState(false);

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleGoHome = () => {
    navigate('/');
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSubmitSuccess = () => {
    // Show success message and switch to bug list tab
    setReportSuccess(true);
    setTabValue(1); // Switch to bug list tab
    
    setTimeout(() => {
      setReportSuccess(false);
    }, 5000);
  };

  return (
    <Box sx={{
      width: '100%',
      backgroundColor: darkMode ? 'background.default' : '#f5f5f5',
      minHeight: '100vh',
    }}>
      <Paper sx={{
        borderRadius: 0,
        padding: 0
      }}>
        <PageHeader 
          darkMode={darkMode} 
          toggleDarkMode={toggleDarkMode}
          showLogout={true}
          themeVariant={themeVariant} 
        />
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2, padding: 1 }}>
          <Button
            variant="outlined"
            color="primary"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
            sx={{ mr: 2 }}
          >
            Home
          </Button>
          {/* Add arrow icon between buttons */}
          <NavigateNextIcon sx={{ mx: 1, color: 'text.secondary', fontSize: 20 }} />
          <Button
            variant="text"
            color="primary"
            startIcon={<MonitorHeartIcon />}
            sx={{ mr: 2 }}
          >
            Support
          </Button>
          <NavigateNextIcon sx={{ mx: 1, color: 'text.secondary', fontSize: 20 }} />
          <Button
            variant="text"
            color="primary"
            startIcon={<BugReportIcon />}
            sx={{ mr: 2 }}
          >
            Report a Bug
          </Button>
        </Box>
        <Box sx={{ mx: 'auto', p: { xs: 1, sm: 2, md: 3 } }}>
          {reportSuccess && (
            <Alert 
              severity="success" 
              sx={{ mb: 3 }}
              onClose={() => setReportSuccess(false)}
            >
              Your bug report has been submitted successfully. View it in the Bug List tab.
            </Alert>
          )}
          
          <Tabs 
            value={tabValue} 
            onChange={handleTabChange}
            sx={{ mb: 3 }}
            leftAlign="start"
          >
            <Tab 
              icon={<BugReportIcon />} 
              label="Report a Bug" 
              iconPosition="start"
            />
            <Tab 
              icon={<CheckCircleIcon />} 
              label="Bug List" 
              iconPosition="start"
            />
          </Tabs>
          
          {tabValue === 0 && (
            <Paper sx={{ p: 3, mb: 4 }}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom>Bug Report</Typography>
                  <BugReportForm onSubmitSuccess={handleSubmitSuccess} />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Typography variant="h6" gutterBottom>Log Collection</Typography>
                  <LogCollector />
                </Grid>
              </Grid>
            </Paper>
          )}
          
          {tabValue === 1 && (
            <Box sx={{ mb: 4 }}>
              {/* Use the existing BugReportsAdmin component */}
              <BugReportsAdmin 
                darkMode={darkMode} 
                embedded={true} // Add an 'embedded' prop to simplify the UI when used inside another page
                onBugUpdated={() => {
                  // Refresh if needed
                }}
              />
            </Box>
          )}
        </Box>
      </Paper>
    </Box>
  );
};

export default BugReportPage;